function getConfigurationVariableFromCypress() {
  return window.Cypress
    ? Object.keys(window.Cypress.expose())
        .filter((key: string) => {
          return key.indexOf("VITE_APP_") === 0;
        })
        .reduce((accumulator: any, key: string) => {
          accumulator[key] = window.Cypress.expose(key);
          return accumulator;
        }, {})
    : {};
}

export function getConfigurationVariable(name: string) {
  const combinedConfigurationVariables = {
    ...import.meta.env,
    ...getConfigurationVariableFromCypress(),
  };
  return combinedConfigurationVariables[name];
}
